import React from "react";
import { View } from "react-native";
import config from "../config/config";

function BlockSeperator({ height = 3.5 }) {
    return (
        <View
            style={{
                paddingVertical: height,
                backgroundColor: config.colors.white,
                borderColor: config.colors.primary,
            }}
        />
    );
}

export default BlockSeperator;
